/**
 * TimelineGradientMask Component
 *
 * Left gradient overlay for Y-axis labels.
 * Creates a fade effect to improve label readability against content.
 */

import React from 'react'
import { Box, useTheme } from '@mui/material'
import { X_AXIS_HEIGHT, Y_AXIS_GRADIENT_MASK_WIDTH } from '../timeline-constants'

/**
 * TimelineGradientMask - Left gradient overlay
 *
 * Gradient fades from opaque (left) to transparent (right) to create
 * visual separation between Y-axis labels and timeline content.
 */
export const TimelineGradientMask = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: X_AXIS_HEIGHT,
        bottom: 0,
        width: Y_AXIS_GRADIENT_MASK_WIDTH,
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(to right, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)'
          : 'linear-gradient(to right, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0) 100%)',
        pointerEvents: 'none',
        zIndex: 5,  // Above week tints (0), below phase indicators (15), hover line (20), ylabel chips (30)
      }}
    />
  )
}
